import React from 'react'
import { Tag } from 'antd'
import { formatNumber } from './formatters'

/**
 * 백엔드 status enum → 한글 라벨/색상.
 * 서비스별로 대/소문자가 혼재되어 있어(vgen 대문자, movie/invoice 소문자) 소문자로 정규화해 매핑한다.
 */
const STATUS_META: Record<string, { label: string; color: string }> = {
  // 공통 결과
  completed: { label: '완료', color: 'green' },
  complete: { label: '완료', color: 'green' },
  success: { label: '완료', color: 'green' },
  failed: { label: '실패', color: 'red' },
  fail: { label: '실패', color: 'red' },
  error: { label: '실패', color: 'red' },
  // 진행/대기
  processing: { label: '진행중', color: 'blue' },
  progress: { label: '진행중', color: 'blue' },
  in_progress: { label: '진행중', color: 'blue' },
  converting: { label: '변환중', color: 'blue' },
  rendering: { label: '렌더링중', color: 'blue' },
  pending: { label: '대기', color: 'gold' },
  waiting: { label: '대기', color: 'gold' },
  queued: { label: '대기', color: 'gold' },
  requested: { label: '요청됨', color: 'gold' },
  canceled: { label: '취소', color: 'default' },
  cancelled: { label: '취소', color: 'default' },
  // invoice 전용
  paid: { label: '결제완료', color: 'green' },
  unpaid: { label: '미결제', color: 'orange' },
  ready: { label: '결제대기', color: 'gold' },
  draft: { label: '임시', color: 'default' },
}

export const statusMeta = (status: string): { label: string; color: string } =>
  STATUS_META[status.toLowerCase()] ?? { label: status, color: 'default' }

/** statusCounts Map → 건수 내림차순 Tag 목록 */
export function StatusTags({ statusCounts }: { statusCounts: Record<string, number> }) {
  const entries = Object.entries(statusCounts).sort(([, a], [, b]) => b - a)
  if (entries.length === 0) return <Tag>데이터 없음</Tag>
  return (
    <>
      {entries.map(([status, count]) => {
        const { label, color } = statusMeta(status)
        return (
          <Tag key={status} color={color} style={{ marginBottom: 4 }}>
            {label} {formatNumber(count)}
          </Tag>
        )
      })}
    </>
  )
}